import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=372d3dd8&scoped=true&"
import script from "./TransitionExpand.vue?vue&type=script&lang=js&"
export * from "./TransitionExpand.vue?vue&type=script&lang=js&"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=372d3dd8&prod&lang=css&"
import style1 from "./TransitionExpand.vue?vue&type=style&index=1&id=372d3dd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d3dd8",
  null
  
)

export default component.exports